// FZ-1499: Hook to handle onboarding redirect
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { clearOnboardingRedirect } from "../../../contexts/auth/slice";

export default function useOnboardingRedirect() {
  const redirectPayload = useSelector(state => state.auth?.redirectPayload);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (redirectPayload) {
      history.push({
        pathname: "/onboarding-contact",
        search: new URLSearchParams(redirectPayload).toString(),
      });
      dispatch(clearOnboardingRedirect());
    }
  }, [redirectPayload, history, dispatch]);
}
